import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, StyleSheet, Image, Dimensions } from 'react-native';
import Modal from 'modal-react-native-web';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';
import ProfileAvatarSelection from '../profileAvatarSelection';
import ProfileAvatarStamp from '../profileAvatar/ProfileAvatarStamp';

const edit = require('../../assets/icons/edit.png');

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.CONTAINER_MARGIN * 3,
    marginLeft: width < 900 ? theme.CONTAINER_MARGIN : 0,
    marginRight: width < 900 ? theme.CONTAINER_MARGIN : 0,
  },
  headerTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE * 3,
    fontFamily: 'Pacifico',
    paddingRight: 15,
  },
  headerStatsContainer: {
    flexDirection: 'row',
  },
  headerStatsText: {
    fontSize: 15,
    fontWeight: 'bold',
    color: theme.GREEN_LIGHT_COLOR,
    paddingRight: 15,
  },
  headerStatsCounter: {
    fontSize: 20,
  },
  profileTurtle: {
    width: width < 900 ? 150 : 200,
    height: width < 900 ? 173 : 230,
    marginBottom: 10,
  },
  profilePictureWrapper: {
    position: 'relative',
  },
  editProfilePic: {
    height: 25,
    width: 25,
    top: 15,
    right: 45,
    position: 'absolute',
    zIndex: 40,
  },
});

export default function ProfileHeader({ currentUser, friendsQuantity, ownProfile, nav }) {
  let turtletQuantity = 0;
  const sentMessages = 'sentMessageCount' in currentUser ? currentUser.sentMessageCount : 0;
  const receivedMessages =
    'receivedMessageCount' in currentUser ? currentUser.receivedMessageCount : 0;
  turtletQuantity = sentMessages + receivedMessages;

  if (currentUser.user === undefined) {
    nav.navigate('Auth');
    return null;
  }

  const profileName = ownProfile && currentUser.user ? currentUser.user.nickname : 'Shelby';
  const avatar = ownProfile && currentUser.user ? currentUser.user.avatar : 'default';
  const [friendsQuantityCounter, setFriendsQuantityCounter] = useState(0);
  const [turtletQuantityCounter, setTurtletQuantityCounter] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    Modal.setAppElement('body');
    setTurtletQuantityCounter(turtletQuantity);
    setFriendsQuantityCounter(friendsQuantity);
  }, [friendsQuantity, currentUser]); // needed to wait until props loaded

  return (
    <View>
      <View style={styles.header}>
        <View style={styles.headerBody}>
          <View style={styles.headerTextContainer}>
            <CustomText style={styles.headerText}>{profileName}</CustomText>
          </View>
          <View style={styles.headerStatsContainer}>
            <View>
              <CustomText style={[styles.headerStatsText, styles.headerStatsCounter]}>
                {friendsQuantityCounter}
              </CustomText>
              <CustomText style={styles.headerStatsText}>Friends</CustomText>
            </View>
            <View>
              <CustomText style={[styles.headerStatsText, styles.headerStatsCounter]}>
                {turtletQuantityCounter}
              </CustomText>
              <CustomText style={styles.headerStatsText}>Turtlets</CustomText>
            </View>
          </View>
        </View>
        <TouchableOpacity
          testID="modal"
          data-test="avatarSelection"
          onPress={() => {
            setModalVisible(true);
            document.body.style.overflow = 'hidden';
          }}
          style={styles.profilePictureWrapper}
        >
          <ProfileAvatarStamp avatar={avatar} style={styles.profileTurtle} />
          <Image style={styles.editProfilePic} source={edit} />
        </TouchableOpacity>
      </View>
      <Modal animationType="slide" transparent testID="modalpopup" visible={modalVisible}>
        <ProfileAvatarSelection
          onCloseModal={() => {
            setModalVisible(false);
            document.body.style.overflow = 'unset';
          }}
        />
      </Modal>
    </View>
  );
}
